var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        _vm._b(
          {
            attrs: {
              action: _vm.action,
              "list-type": "picture",
              "before-upload": _vm.beforeUpload,
              "on-success": _vm.handleSuccess,
              "on-exceed": _vm.handleExceed,
              data: _vm.formData,
              "show-file-list": "",
              limit: 1,
              "file-list": _vm.internalFileList,
              "auto-upload": true,
            },
          },
          "el-upload",
          _vm.$attrs,
          false
        ),
        [
          _c("el-button", { attrs: { size: "small", type: "primary" } }, [
            _vm._v("点击上传"),
          ]),
          _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip",
            },
            [_vm._v("只能上传jpg/png文件，且不超过500kb")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }